import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0f64fa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-group list-group-flush" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mt-2 pi pi-download" }, null, -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentUrl, (item, i) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "list-group-item",
        key: i,
        title: item.label
      }, [
        (item?.image !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: require(`../../../../assets/placeholder/${item.image}`),
                alt: item.image,
                class: "img-fluid",
                width: "60"
              }, null, 8, _hoisted_4),
              _createElementVNode("a", {
                href: `${item.link}`,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "",
                download: ""
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  _hoisted_7
                ])
              ], 8, _hoisted_5)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("img", {
                src: require(`../../../../assets/placeholder/pdf.svg`),
                alt: item.image,
                style: {"visibility":"hidden"},
                width: "60"
              }, null, 8, _hoisted_9),
              _createElementVNode("a", {
                href: `${item.link}`,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(item.label) + " ", 1)
              ], 8, _hoisted_10)
            ]))
      ], 8, _hoisted_2))
    }), 128))
  ]))
}